import { useEffect, useState } from 'react';

import { useGoogleSync } from './useGoogleSync';

export const RELATIONSHIP_STRENGTH_POLLING_INTERVAL = 30000;

const isProcessing = ({
  relationshipStrengthEnabled,
  relationshipStrengthInitialSync,
  relationshipStrengthSyncStatus,
}) =>
  relationshipStrengthEnabled === true &&
  relationshipStrengthInitialSync === true &&
  ['pending', 'calculating'].includes(relationshipStrengthSyncStatus);

export function useRelationshipStrengthSync() {
  const [pollingInterval, setPollingInterval] = useState(0);
  const googleSyncState = useGoogleSync({
    pollingInterval,
    skipPollingIfUnfocused: true,
    refetchOnFocus: pollingInterval > 0,
  });

  const shouldPoll = isProcessing(googleSyncState.googleSync);

  useEffect(() => {
    setPollingInterval(shouldPoll ? RELATIONSHIP_STRENGTH_POLLING_INTERVAL : 0);
  }, [shouldPoll]);

  return googleSyncState;
}
